// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Attività',
    ActivityActualCompletionDateCondition_Text: 'Data effettiva di completamento attività',
    ActivityActualGreaterThanEstimated_Text: 'Attività sottostimate',
    ActivityCreationDateCondition_Text: 'Data di creazione dell\'attività',
    ActivityCreator_Text: 'Creatori dell\'attività',
    ActivityCreatorCondition_Text: 'Creatore dell\'attività',
    ActivityCustomFieldCondition_Text: 'Campi personalizzati dell\'Attività',
    ActivityEndDateCondition_Text: 'Data termine attività',
    ActivityHealthCondition_Text: 'Salute dell\'attività',
    ActivityHealthTypes: 'Salute dell\'attività',
    ActivityProcessCondition_Text: 'Avanzamento dell\'attività:',
    ActivityProgress_Text: 'Avanzamento dell\'attività:',
    ActivityStartDateCondition_Text: 'Data di inizio dell\'attività',
    ActivityStatusCondition_Text: 'Status dell\'attività',
    ActivityTypeCondition_Text: 'Tipo attività:',
    ActivityTypes_Issue: 'Problema',
    ActivityTypes_Request: 'Richiesta',
    ActivityTypes_Task: 'Compito',
    ActivityTypesCondition_Text: 'Tipi attività',
    ActualCompletionDate_Text: 'Data di completamento effettivo:',
    AdvancedFilterTooltipContent_Text: 'Cliccare qui per visualizzare tutte le opzioni di filtraggio possibili',
    AdvancedFilterTooltipTitle_Text: 'Filtri avanzati',
    AllActivities_Text: 'Attività',
    Apply_Text: 'Applicare',
    AssigneeCondition_Text: 'Destinatario dell\'attività',
    AssigneeOption_Text: 'Destinatari dell\'attività',
    AssigneeUserCondition_Empty_Text: 'Nessun destinatario',
    AssigneeUserCondition_Entity: 'destinatari dell\'attività',
    BoolCustomField_NotSelected_Text: 'Non selezionato',
    BoolCustomField_Yes_Text: 'Sì',
    CategoriesCondition_Text: 'Categorie',
    CategoryCondition_Empty_Text: 'Senza categoria',
    CategoryCondition_Entity: 'categorie',
    CategoryCondition_Text: 'Categoria',
    Clear_All_Text: 'Cancellare Tutto',
    CompletedStatus_Text: 'Completata',
    ContainMore_Text: 'Sono presenti altri risultati, continuare a scrivere...',
    CreationDate_Text: 'Data di creazione',
    CustomerCondition_Empty_Text: 'Nessun cliente',
    CustomerCondition_Entity: 'clienti',
    CustomerCondition_Text: 'Clienti',
    EndDate_Text: 'Data di completamento',
    FilterByKeyword_Text: 'Filtra per parola chiave',
    FilterByPeriod_Text: 'Filtra per periodo',
    FilterByTimeframe_Text: 'Filtra per tempo',
    FilterTabs_Tab1: 'Stati',
    FilterTabs_Tab2: 'Risorse e Limiti',
    FilterTabs_Tab3: 'Salute e Progresso',
    FilterTabs_Tab4: 'Progetti, Clienti ed altro',
    FilterTabs_Tab5: 'Campi personalizzati',
    From_Text: 'da:',
    HealthCondition_Text: 'Salute',
    HealthItemType_Bad: 'Allarme',
    HealthItemType_Good: 'Buona',
    HealthItemType_Medium: 'A rischio',
    HealthItemType_NotCalculated: 'Non calcolata',
    HealthTooltip_Text: 'La salute è un indice calcolato che mostra quanto bene sta andando un progetto o un\'attività',
    HealthTooltipLink_Text: 'Visualizza ulteriori informazioni nella nostra guida online',
    HoursCondition_Text: 'Tempo',
    InProgressStatus_Text: 'Il mio lavoro',
    InvalidDate: 'La data deve essere in formato \'{0}\'.',
    Issue_Text: 'Problema',
    KeepTyping_Text: 'Continua a scrivere...',
    ListCustomFieldCondition_Empty_Text: 'Non selezionato',
    ManualRange: 'Campo data specificato...',
    Me: 'Io',
    Menu_Dates: 'Date',
    Milestone_Text: 'Tappa Fondamentale',
    MoneyCondition_Text: 'Denaro',
    More_Text: 'Altro',
    NextMonth: 'Mese successivo',
    NextWeek: 'Settimana successiva',
    NoCategory: 'Senza categoria',
    NoMatch_Text: 'Mi dispiace, non è stato trovato nulla',
    OnHoldStatus_Text: 'In attesa',
    PeopleCondition_Text: 'Persone',
    PinTooltip_Text: 'Fissare',
    Portfolio_Status_Text: 'Status del portfolio',
    PortfolioCondition_Empty_Text: 'Nessun portfolio',
    PortfolioCondition_Entity: 'portfolios',
    PortfolioCreator_Text: 'Creatori portfolio',
    PortfolioCreatorCondition_Text: 'Creatore portfolio',
    PortfolioManager_Text: 'Managers del Portfolio',
    PortfolioManagerCondition_Text: 'Manager del Portfolio',
    PreviousMonth: 'Mese precedente',
    PreviousWeek: 'Settimana precedente',
    PreviousYear: 'Anno precedente',
    PriorityCondition_Text: 'Priorità',
    ProgressCondition_Entity: 'Progresso: ',
    ProgressCondition_Text: 'Progresso',
    Project_Text: 'Progetto',
    ProjectActualCompletionDateCondition_Text: 'Data effettiva di completamento del progetto',
    ProjectActualGreaterThanEstimated_Text: 'Progetti sottostimati',
    ProjectCondition_Entity: 'progetti',
    ProjectCondition_Text: 'Progetti',
    ProjectCostExceedBudget_Text: 'Progetti non compresi nel budget',
    ProjectCreationDateCondition_Text: 'Data di creazione del progetto',
    ProjectCreator_Text: 'Creatori del progetto',
    ProjectCreatorCondition_Text: 'Creatore del progetto',
    ProjectCustomFieldCondition_Text: 'Campi personalizzati del progetto',
    ProjectEndDateCondition_Text: 'Data di termine del progetto',
    ProjectHealthCondition_Text: 'Salute del progetto',
    ProjectHealthTypes: 'Salute del progetto',
    ProjectManager_Text: 'Managers del progetto',
    ProjectManagerCondition_Text: 'Manager del progetto',
    ProjectMemberCondition_Text: 'Membro del progetto',
    ProjectPriorityCondition_Text: 'Priorità del progetto',
    ProjectPriorityCondition_Text_Template: 'Progetti con priorità %s',
    ProjectProcessCondition_Text: 'Progresso del progetto',
    ProjectProfit_Text: 'Progetti in perdita finanziaria',
    ProjectProgress_Text: 'Progresso del progetto',
    ProjectsAndTasksList_Title: 'Progetti & Compiti',
    ProjectStartDateCondition_Text: 'Data inizio progetto',
    ProjectStatusCondition_Text: 'Status del progetto',
    QuickFilterWatermark: 'Filtra per...',
    range_condition_text: 'Gamma',
    Request_Text: 'Richiesta',
    roles_condition_text: 'Ruoli',
    SaveFilters_Title: 'Filtri salvati',
    StartDate_Text: 'Data di inizio',
    StatusesCountFormat: '1#stati {0} #status {0}',
    Task_Text: 'Compito',
    TaskCondition_Entity: 'attività',
    TaskCondition_Text: 'Attività',
    TaskCostExceedBudget_Text: 'Attività non comprese nel budget',
    TaskPriorityCondition_Entity: 'priorità dell\'attività',
    TaskPriorityCondition_Text: 'Priorità del Compito',
    TaskPriorityCondition_Text_Template: 'Attività con priorità %s',
    TasksAssignedToMilestone_Text: 'Attività assegnata alla tappa fondamentale',
    ThisMonth: 'Questo mese',
    ThisWeek: 'Questa settimana',
    ThisYear: 'Quest\'anno',
    To_Text: 'a:',
    Today: 'Oggi',
    TypesCondition_Text: 'Tipi',
    UnpinTooltip_Text: 'Non fissare',
    users_condition_text: 'Utenti',
    Yesterday: 'Ieri',
};
